// Tipos de turno en ANSES (TipoTurnoAnses en el backend): a qué se va. Fuente única de etiquetas,
// íconos y textos para la tarjeta del trámite, la página de Turnos ANSES y el turnero.
//
// Solo PRESENTACION genera presentación con resultado, mueve el estado del trámite y cuenta en las
// estadísticas. VISTA y CITACION no tienen turno del organismo: la hora que se carga es la del turno
// en el estudio, y se cierran dejando una observación.
export const TIPOS_TURNO_ANSES = [
    {
        valor: 'PRESENTACION',
        etiqueta: 'A presentar',
        etiquetaLarga: 'Presentación',
        icono: 'bi-folder-symlink',
        ayuda: 'Se lleva documentación: genera la presentación y mueve el estado del trámite.',
    },
    {
        valor: 'VISTA',
        etiqueta: 'A tomar vista',
        etiquetaLarga: 'Vista de expediente',
        badge: 'Vista',
        icono: 'bi-eyeglasses',
        ayuda: 'Se va a mirar un expediente: no mueve el estado del trámite ni cuenta como presentación. La hora que cargues es la del turno en el estudio.',
        enTurnero: 'Vista en ANSES',
        detalleTurnero: 'Va a tomar vista de un expediente',
        cierre: 'la vista',
        placeholderCierre: 'Qué se vio del expediente...',
    },
    {
        valor: 'CITACION',
        etiqueta: 'Citación de ANSES',
        etiquetaLarga: 'Citación de ANSES',
        badge: 'Citación de ANSES',
        icono: 'bi-envelope-paper',
        ayuda: 'ANSES citó a la persona: viene al estudio y va acompañada por un abogado. No mueve el estado del trámite ni cuenta como presentación. La hora que cargues es la del turno en el estudio.',
        enTurnero: 'Citación de ANSES',
        detalleTurnero: 'Citado por ANSES: sale del estudio acompañado por un abogado',
        cierre: 'la citación',
        placeholderCierre: 'Qué pasó en la citación...',
    },
];

/** Datos del tipo; un tipo desconocido o vacío se toma como PRESENTACION, igual que el backend. */
export function metaTipoTurnoAnses(tipo) {
    return TIPOS_TURNO_ANSES.find((t) => t.valor === tipo) || TIPOS_TURNO_ANSES[0];
}

/** Vista y citación: sin turno del organismo, sin presentación con resultado y sin mover el trámite. */
export function esSinPresentacion(tipo) {
    return tipo === 'VISTA' || tipo === 'CITACION';
}
